<template>
  <section class="bg-white py-16 sm:py-24">
    <div class="container mx-auto px-4">

      <h2 class="text-center text-3xl md:text-4xl font-semibold text-gray-800 tracking-tight leading-tight max-w-4xl mx-auto">
        Sua operação em ordem, sua equipe<br />conectada e seu cliente sempre informado.
      </h2>

      <div class="mt-16 max-w-6xl mx-auto">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          
          <div v-for="feature in features" :key="feature" class="bg-orange-500 text-white font-semibold text-center rounded-xl flex items-center justify-center p-6 min-h-[150px] transition-transform hover:-translate-y-1">
            <p>{{ feature }}</p>
          </div>

        </div>
        
        <div class="mt-6">
          <div class="w-32 h-1.5 bg-orange-500 rounded-full"></div>
        </div>

      </div>

      <div class="mt-16 text-center">
        <button 
          @click="startFreeTrial"
          class="bg-gray-900 text-white font-medium py-3.5 px-7 rounded-full inline-flex items-center gap-x-3 group transition-transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
        >
          <span>Comece agora. É grátis</span>
          <span class="bg-white rounded-full p-1 flex items-center justify-center">
            <svg class="w-4 h-4 text-red-500 group-hover:rotate-45 transition-transform" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
            </svg>
          </span>
        </button>
      </div>

    </div>
  </section>
</template>

<script>

import { getWhatsAppLink } from '@/utils/whatsapp';

export default {
  name: 'FeaturesSection',
  data() {
    return {
      features: [
        'Gestão centralizada de pedidos em tempo real',
        'Monitoramento de entregas e desempenho',
        'Aplicativos nativos (inclusive app para garçons)',
        'Visão da cozinha e status de produção',
        'Notificações automáticas no WhatsApp para seus clientes',
        'Relatórios detalhados para decisões inteligentes',
        'Recursos de marketing e promoções com foco em fidelização',
        'Integração com o iFood',
        'Suporte dedicado e segurança aprimorada',
      ],
    };
  },
  methods: {
    startFreeTrial() {
      const message = "Olá! Quero começar meu teste gratuito na OverX.";
      const link = getWhatsAppLink(message);
      window.open(link, "_blank");
    }
  }
}
</script>
